import { Button, ButtonProps } from "@blueprintjs/core";

const CustomButton = (props: ButtonProps) => {
	return (
		<Button {...props} />
	);
};

export default CustomButton;
